import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export abstract class ImportConfigurationInterface {
  uploadConfigurationSet: (data:any) => Observable<any[]>;
  importConfigurationSet: (data:any) => Observable<any[]>;
}

